"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionNoteStatus = void 0;
// Different parts of the session note can be at different statuses.
var SessionNoteStatus = /*#__PURE__*/function (SessionNoteStatus) {
  SessionNoteStatus["Submitted"] = "submitted";
  SessionNoteStatus["Draft"] = "draft";
  SessionNoteStatus["Discarded"] = "discarded";
  return SessionNoteStatus;
}({});
exports.SessionNoteStatus = SessionNoteStatus;